import React from "react";
import { observer } from "mobx-react";
import { Switch } from "antd";
import Group from "../group";
import notify from "@app/components/notify";

const SlrToggle = observer(({ config, onChange, readonly = false }) => {
    if (!config) {
        return null;
    }

    const handleToggle = async (key, value) => {
        if (!onChange) {
            return;
        }

        try {
            await onChange({ [key]: value });
        } catch (error) {
            notify.error("Error updating DUE configuration");
        }
    };

    return (
        <Group title="DUE Configuration">
            <div className="toggle">
                <div className="row items-center mb-15 ml-15">
                    <Switch
                        checked={Boolean(config.enabled)}
                        onChange={(value) => handleToggle("enabled", value)}
                        disabled={readonly}
                        aria-label="Toggle DUE configuration"
                    />
                    <div className="col ml-15">Enable DUE</div>
                </div>
            </div>
        </Group>
    );
});

export default SlrToggle;
